<template>
  <pt-notice-form class="pt-notice-form__page" :isEdit="is_edit" :id="id"></pt-notice-form>
</template>

<script>
import PtNoticeForm from 'cps/information-manage/pt-notice-manage/pt-notice-form'
export default {
  name: 'pt-notice-form__view',
  components: {
    'pt-notice-form': PtNoticeForm
  },
  props: {
    isEdit: {
      type: [String, Boolean],
      default: false
    },
    id: {
      type: String,
      default: ''
    }
  },
  data () {
    return {
      is_edit: this.isEdit === 'true'
    }
  }
}
</script>
